var _                         = require('underscore');
var $                         = require('jquery');
var TrayTabContent            = require('./tray__tab__content.js');
var TrayTabGridComponentsItem = require('./tray__tab__gridcomponents__item.js');

/**
 * Creates an overlay tray large components
 *
 * @class
 */

class TrayTabLargeComponents extends TrayTabContent {
 
    _defaults() {
        return {
            target: '.js-editor',
            fields: {}
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="grid editor__tray__largecomponents ` + ((options && options.viewConfig && options.viewConfig.darkThumbs) ? "editor__tray__largecomponents--dark" : "") + `">
                <div class="js-editor__tray__content"></div>
            </div>
        `;

        super.render();
    }

    /*
     * Add an item to the tray content list
     * @param dataObj - json object
     * @param dataObj.name
     * @param dataObj.description
     * @param dataObj.thumbUrl
    */

    addItem(defaults, overlayProperties, overlay){

        return new TrayTabGridComponentsItem({
            target: $(".js-editor__tray__content", this.$el),
            fields: {
                "defaults": defaults,
                "overlay_properties": overlayProperties,
                "overlay": overlay
            }
        })
    }


}
module.exports = TrayTabLargeComponents;